/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Cod_Override_InvalidInputs */

const vi_carrier_form_cod_override_invalid = /** @type {(inputs: Carrier_Form_Cod_Override_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền thu hộ phải là số không âm.`)
};

/**

* @param {Carrier_Form_Cod_Override_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override_invalid = /** @type {((inputs?: Carrier_Form_Cod_Override_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Override_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override_invalid(inputs)
});